import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { CustomDialog } from "azure-devops-ui/Dialog";
import { Image } from "azure-devops-ui/Image";
import { Observer } from "azure-devops-ui/Observer";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { CustomHeader, HeaderTitleArea } from "azure-devops-ui/Header";
import { PanelContent, PanelFooter } from "azure-devops-ui/Panel";
import "./Dialog.Example.css";

export default class CustomDialogExample extends React.Component {
    private isDialogOpen = new ObservableValue<boolean>(false);

    public render() {
        const onDismiss = () => {
            this.isDialogOpen.value = false;
        };

        return (
            <div>
                <Button
                    text="Open Dialog"
                    onClick={() => {
                        this.isDialogOpen.value = true;
                    }}
                />
                <Observer isDialogOpen={this.isDialogOpen}>
                    {(props: { isDialogOpen: boolean }) => {
                        return props.isDialogOpen ? (
                            <CustomDialog onDismiss={onDismiss} modal={true}>
                                <CustomHeader className="bolt-header-with-commandbar" separator>
                                    <HeaderTitleArea>
                                        <div
                                            className="flex-grow scroll-hidden"
                                            style={{ marginRight: "16px" }}
                                        >
                                            <div
                                                className="title-m"
                                                style={{
                                                    height: "500px",
                                                    width: "100%",
                                                    maxHeight: "32px"
                                                }}
                                            >
                                                Cumulative Flow
                                            </div>
                                        </div>
                                    </HeaderTitleArea>
                                </CustomHeader>
                                <PanelContent>
                                    <Image className="cumulative-flow-image"
                                        src={require("./cumulativeflow.png")}
                                        containImage={true}
                                    />
                                </PanelContent>
                                <PanelFooter showSeparator className="body-m">
                                    This chart shows the count of work items over time.
                                </PanelFooter>
                            </CustomDialog>
                        ) : null;
                    }}
                </Observer>
            </div>
        );
    }
}
